export default function Slider() {
  return {}
}
